import { signOut } from 'next-auth/react';
import { signOutMessage } from './services/postMessageService';
import { authLinkSignout } from '../comlink/AuthLink';

export function doSignout() {
    // trying to go to call signOut with redirect causes infinite loop because it incorrectly tries to
    // perform a redirect back
    signOut({ redirect: false });
    signOutMessage();
    authLinkSignout();
}
